import { AccountActivityAPI } from 'api/AccountActivityAPI'

export const sendDigestEmail = () => {
  return AccountActivityAPI.post('/v2/email_digest/send').then(res => res.data)
}

export const generateDemoData = (accountId: string, contactEmail: string) => {
  return AccountActivityAPI.post('/demo/generation/account', { accountId, contactEmail }).then(
    res => res.data
  )
}
